"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=corporate-contact.dto.js.map